export * from "./SvgAdd";
export * from "./SvgArrival";
export * from "./SvgArrowRight";
export * from "./SvgArrowTop";
export * from "./SvgCalendar";
export * from "./SvgCharter";
export * from "./SvgCheck";
export * from "./SvgClose";
export * from "./SvgCompany";
export * from "./SvgDelete";
export * from "./SvgDeparture";
export * from "./SvgDirection";
export * from "./SvgEdit";
export * from "./SvgFreight";
export * from "./SvgHamburgerMenu";
export * from "./SvgHome";
export * from "./SvgInfo";
export * from "./SvgJetOneSuites";
export * from "./SvgLocation";
export * from "./SvgLogout";
export * from "./SvgNotification";
export * from "./SvgPending";
export * from "./SvgDashboard";
export * from "./SvgPhone";
export * from "./SvgPlus";
export * from "./SvgProfile";
export * from "./SvgReject";
export * from "./SvgSearch";
export * from "./SvgSeen";
export * from "./SvgSetting";
export * from "./SvgTime";
export * from "./SvgUnseen";
export * from "./SvgVariant";
export * from "./SvgWebsiteContent";
export * from "./SvgFacebook";
export * from "./SvgInsta";
export * from "./SvgLinkedin";
export * from "./SvgTwitter";
export * from "./SvgIconOneWay";
export * from "./SvgIconRoundtrip";
export * from "./SvgIconMultiLeg";
export * from "./SvgArrowLeft";
export * from "./SvgWarningSolid";
export * from "./SvgErrorFill";
export * from "./SvgInfoFill";
export * from "./SvgSuccessFill";
export * from "./SvgSuccessOutline";
export * from "./SvgWarningFill";
export * from "./SvgUser";
export * from "./SvgJOSAircraft";
export * from "./SvgJOSHome";
export * from "./SvgPaperClip";
export * from "./SvgSpinner";
export * from "./SvgIconX";
export * from "./SvgJOSFuel";
export * from "./SvgRemovePassenger";
export * from "./SvgAddPassenger";
export * from "./SvgArrowStraightRight";
export * from "./SvgSeparator";
export * from "./SvgAirFreight";
export * from "./SvgPlusOutline";
export * from "./SvgMessage";
export * from "./SvgAirplaneSeat";
export * from "./SvgInvited";
export * from "./SvgCheckCircle";
export * from "./SvgCamera";
export * from "./SvgArrowDown";
export * from "./SvgExpertise";
export * from "./SvgHotline";
export * from "./SvgSuitesAndFacilities";
export * from "./SvgBookings";
export * from "./SvgClear";
export * from "./SvgStar";
export * from "./SvgBackToTop";
export * from "./SvgRoyalAir";
export * from "./SvgPartnerAircraft";
export * from "./IconTrustedPartnersExceptional";
export * from "./IconTrustedPartnersModern";
export * from "./IconTrustedPartnersProvenSafety";
export * from "./IconTrustedPartnersReliability";
